
<div class="container">
  <div class="row">
    <div class="col">
      <p class="text-center">Import the completed Partner Installation spreadsheet</p>
      <p class="text-center">Warning: Upload only XLSX file since uploading XLSM file is not permitted as per HP Cyber security policy</p>
      <p class="text-center">If you require any assistance in converting an XLSM file to XLSX file, follow the steps given <a href="javascript:void(0);" (click)="DialogToConvertToXlsx()">here.</a></p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" id="importPartnerInstallation" [uploadFileTo]="'/api/deploymentworkflow/import-partner-install?projectId=' + projectId + '&amp;deploymentId=' + deploymentId" [fileExtensions]="['xls', 'xlsx']" [title]="'Import Partner Installation Form'"><span class="oi oi-cloud-upload"></span> Upload Partner Installation Form</a></div>
    <div class="col"> </div>
  </div>
</div>